
import Vue from 'vue'
import { ymapMarker as YmapMarker } from 'vue-yandex-maps'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  components: { YmapMarker },
  mixins: [staticBlockMixin],
  props: {
    point: {
      type: String,
      required: true
    }
  }
})
